import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'pcm-table-filter-field-boolean',
	templateUrl: './table-filter-field-boolean.component.html'
})
export class TableFilterFieldBooleanComponent {
	@Input() name: string;
	@Input() value: boolean;
	@Input() helpMessage: string;
	@Output() valueChange = new EventEmitter<Boolean>();
	@Output() onValueSelected = new EventEmitter<void>();

	changeValue(value): void {
		this.valueChange.emit(value);
		this.onValueSelected.emit(value);
	}
}
